<template>
  <ol
    class="raw-body-3 grid list-none gap-12 text-[var(--raw-darkgrey)] [overflow-wrap:anywhere]"
  >
    <li
      v-for="(footnote, index) in footnotes"
      :key="index"
      :value="index + 1"
      class="leading-[1.2]"
    >
      <p
        v-for="(block, paragraph) in footnote.body"
        :key="paragraph"
        class="[&:not(:last-child)]:mb-8"
      >
        <FootnoteMarker
          v-if="paragraph === 0"
          :marker="footnoteMarker(index)"
          class="me-4"
        /><InlineMarkdown :message="block.text" /><SourceMarker
          :refs="block.sourceRefs"
          :zone
        />
      </p>
    </li>
  </ol>
</template>

<script setup lang="ts">
import FootnoteMarker from '~/scopes/campaign/components/UI/FootnoteMarker.vue'
import InlineMarkdown from '~/scopes/campaign/components/UI/InlineMarkdown.vue'
import SourceMarker from '~/scopes/campaign/components/UI/SourceMarker.vue'
import { footnoteMarker } from '~/scopes/campaign/data/metals/footnotes'
import type { MetalFootnote } from '~/scopes/campaign/data/metals/types'

// The notes at the foot of a metal sheet. A sibling of `SourcesList` rather than a mode of
// it: a source is one paragraph and the list owns its numbering, whereas a note runs to
// several paragraphs and each one cites the bibliography on its own — the client writes
// `[3]` mid-note and that has to resolve to the same clickable marker prose gets.
//
// The note's own marker goes through `FootnoteMarker`, the same component the prose uses, so
// the `*` here and the `*` on the marked word can't drift apart — matching them by eye is the
// entire mechanism. It sits inside the *first* paragraph rather than above the run: a `<span>`
// beside a `<p>` is a block sibling and would strand the marker on its own line.
// `value` on the `<li>` keeps ordinals right for assistive tech, since the marker is drawn
// rather than being a native bullet — the same trade `SourcesList` makes, and the reason both
// need `overflow-wrap: anywhere` (see its note: a citation prints its URL as the link text).
//
// Comments live here, never inside a `v-for` — one there is re-emitted per iteration (see
// `UI/InlineMarkdown.vue`).
defineProps<{
  footnotes: readonly MetalFootnote[]
  /** Tracking surface of the host view, forwarded to each paragraph's citation. */
  zone: string
}>()
</script>
